import { CommonModule } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";

import { GamingExternalModule } from "../data/module";

import { GameLauncherConfigService } from "./game-launcher/game-launcher.config";
import { GameThumbnailWrapperContainer } from "./game-thumbnail/game-thumbnail-wrapper/game-thumbnail-wrapper.container";

export const DIRECTIVES: unknown[] = [GameThumbnailWrapperContainer];

@NgModule({
	imports: [CommonModule, TranslateModule, GamingExternalModule],
	exports: [DIRECTIVES],
	providers: [GameLauncherConfigService],
	declarations: [DIRECTIVES],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class GamingExternalUiModule {}
